import React, { useEffect, useState, useRef } from "react";
import {
    Card, CardBody, Row, Col, Input, Button, Table, Badge
} from "reactstrap";
import AsyncSelect from "react-select/async";
import { useDispatch, useSelector } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import { toast } from "react-toastify";
import { getCookie, textCapitalize } from "../../Helpers/Utils";

const Quotation = () => {
    const dispatch = useDispatch();
    const user = useSelector(s => s.customer.customer);
    const loading = useSelector(state => state.loading.loading);

    const [products, setProducts] = useState([]);
    const [search, setSearch] = useState("");
    const [cart, setCart] = useState([]);
    const [customerOption, setCustomerOption] = useState(null);

    // POS style cart calculations
    const cartSubtotal = cart.reduce((sum, i) => sum + (i.price * i.qty), 0);
    const cgstTotal = cart.reduce((sum, i) => sum + ((i.price * i.qty) * (Number(i.gst_rate) / 2)) / 100, 0);
    const sgstTotal = cart.reduce((sum, i) => sum + ((i.price * i.qty) * (Number(i.gst_rate) / 2)) / 100, 0);
    const grandTotal = cartSubtotal + cgstTotal + sgstTotal;

    const loadProducts = async () => {
        const res = await Handler({
            method: "get",
            url: `/products/search.php?outlet_id=${user.outlet_id}&q=${search}`
        });
        if (res?.success) setProducts(res.data || []);
    };

    useEffect(() => { loadProducts(); }, [search]);

    const addToCart = (p, v = null) => {
        const key = v ? `v-${v?.variant_id}` : `p-${p?.product_id}`;
        setCart(c => {
            const e = c.find(i => i.key === key);
            if (e) return c.map(i => i.key === key ? { ...i, qty: i.qty + 1 } : i);
            return [...c, {
                key,
                product_id: p.product_id,
                variant_id: v?.variant_id || null,
                name: v ? `${p.name} (${v.name})` : p.name,
                qty: 1,
                price: v ? v.discounted_price : p.discounted_price,
                gst_rate: v ? v.gst_rate : p.gst_rate
            }];
        });
    };

    const updateQty = (key, qty) => {
        if (qty <= 0) setCart(c => c.filter(i => i.key !== key));
        else setCart(c => c.map(i => i.key === key ? { ...i, qty } : i));
    };

    const searchCustomers = async (input) => {
        if (!input) return [];
        const res = await Handler({
            method: "get",
            url: `/customers/search_cus.php?q=${input}&outlet_id=${user.outlet_id}`
        });
        return res?.success ? res.data.map(c => ({ value: c.id, label: `${c.name} - ${c.phone}` })) : [];
    };


    const createQuotation = async () => {
        if (!cart.length) return toast.error("Cart empty");
        if (!customerOption) return toast.error("Please Select Customer");
        dispatch(loadingTrue());
        const res = await Handler({
            method: "post",
            url: "/quotation/create.php",
            data: JSON.stringify({
                outlet_id: user.outlet_id,
                customer_id: customerOption?.value || null,
                items: cart.map(i => ({
                    product_id: i.product_id,
                    variant_id: i.variant_id,
                    quantity: i.qty
                }))
            }),
            headers: {
                "Content-Type": "application/json"
            }
        });

        dispatch(loadingFalse());
        if (res?.success) {
            toast.success("Quotation generated");
            setTimeout(() => {
                fetchPdf(res?.data?.quotation_id);
            }, 500);
            setCart([]);
        }
    };

    const fetchPdf = (id) => {
        const token = getCookie('token');
        const w = window.open("", "_blank");
        // fetch("http://localhost/qads-billing/apis/quotation/generate.php", {
        fetch("https://billing.qads.co.in/qads-billing/apis/quotation/generate.php", {
            method: "POST",
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
            body: JSON.stringify({ quotation_id: id, outlet_id: user.outlet_id })
        })
            .then(res => res.blob())
            .then(blob => { w.location.href = URL.createObjectURL(blob); });
    };

    return (
        <div className="p-3">
            <Row className="mb-3 align-items-center">
                <Col><h5>Create Quotation</h5></Col>
            </Row>

            <Row className="g-3">
                {/* LEFT: POS STYLE PRODUCT LIST */}
                <Col md={8}>
                    <Input
                        placeholder="Scan / Search product"
                        className="mb-3"
                        onChange={e => setSearch(e.target.value)}
                    />
                    <Card className="shadow-sm border-0">
                        <CardBody className="p-0">
                            <Table hover responsive className="mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Item</th>
                                        <th>SKU / Barcode</th>
                                        <th className="text-center">Stock</th>
                                        <th className="text-end">Price</th>
                                        <th className="text-end">Add</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {products && products?.map(p => (
                                        <React.Fragment key={p.product_id}>
                                            <tr className="align-middle">
                                                <td className="fw-bold">{p.name}</td>
                                                <td className="small text-muted">
                                                    SKU: {p.meta?.sku || "-"}<br />
                                                    BC: {p.meta?.barcode || "-"}
                                                </td>
                                                <td className="text-center">
                                                    <Badge color={p.quantity > 0 ? "success" : "danger"} pill>
                                                        {p.quantity}
                                                    </Badge>
                                                </td>
                                                <td className="text-end fw-bold">₹{Number(p.discounted_price).toFixed(2)}</td>
                                                <td className="text-end">
                                                    <Button size="sm" color="dark" onClick={() => addToCart(p)}>+</Button>
                                                </td>
                                            </tr>
                                            {p.variants?.map(v => (
                                                <tr key={v.variant_id} className="text-muted small align-middle">
                                                    <td className="ps-4">↳ {v.name}</td>
                                                    <td>
                                                        SKU: {v.sku || "-"}<br />
                                                        BC: {v.barcode || "-"}
                                                    </td>
                                                    <td className="text-center">{v.quantity}</td>
                                                    <td className="text-end">₹{Number(v.discounted_price).toFixed(2)}</td>
                                                    <td className="text-end">
                                                        <Button size="sm" color="warning" onClick={() => addToCart(p, v)}>+</Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </Table>
                        </CardBody>
                    </Card>
                </Col>

                {/* RIGHT: POS STYLE BILLING PANEL */}
                <Col md={4}>
                    <Card className="shadow-sm border-0 mb-3">
                        <CardBody>
                            <label className="small fw-bold mb-1">Customer Selection</label>
                            <AsyncSelect
                                cacheOptions
                                loadOptions={searchCustomers}
                                onChange={setCustomerOption}
                                value={customerOption}
                                placeholder="Search Customer (Optional)"
                                isClearable
                            />
                        </CardBody>
                    </Card>

                    <Card className="shadow-sm border-0">
                        <CardBody>
                            <h6 className="fw-bold">Items List</h6>
                            <hr className="my-2" />
                            <div style={{ minHeight: '150px' }}>
                                {cart && cart?.map(i => (
                                    <div key={i.key} className="d-flex justify-content-between mb-3">
                                        <div className="small">
                                            <div className="fw-bold">{textCapitalize(i.name)}</div>
                                            <div className="text-muted">₹{i.price} × {i.qty}</div>
                                        </div>
                                        <div className="text-end">
                                            <div className="fw-bold">₹{(i.price * i.qty).toFixed(2)}</div>
                                            <Button size="sm" color="link" className="text-danger p-0" onClick={() => updateQty(i.key, 0)}>Remove</Button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <hr />
                            <div className="d-flex justify-content-between small text-muted mb-1">
                                <span>CGST</span><span>₹{cgstTotal.toFixed(2)}</span>
                            </div>
                            <div className="d-flex justify-content-between small text-muted mb-2">
                                <span>SGST</span><span>₹{sgstTotal.toFixed(2)}</span>
                            </div>
                            <div className="d-flex justify-content-between fw-bold fs-5 mb-3">
                                <span>Grand Total</span>
                                <span className="text-success">₹{grandTotal.toFixed(2)}</span>
                            </div>
                            <Button className="w-100 add-btn fw-bold py-2" disabled={loading || !cart.length} onClick={createQuotation}
                            >
                                GENERATE QUOTATION
                            </Button>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default Quotation;